export default __webpack_public_path__ + "static/media/webAgent.de86e02e.png";